export const getStatusTagClassName = (status: string): string => {
  switch (status) {
    case 'completed':
      return 'tag--success-rounded';
    case 'error':
      return 'tag--danger-rounded';
    case 'queued':
    case 'processing':
      return 'tag--info-rounded';
    default:
      return 'tag--muted-rounded';
  }
};
